import { InputSwitch } from 'primereact/inputswitch';  

const InputSwitchz = ({...rest}) => {

    return (
        <InputSwitch checked={false} {...rest} />
    )

};

export default InputSwitchz;